import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IconCheckbox} from "./icon-checkbox";

@Component({
  selector: 'brt-icon-checkbox',
  templateUrl: './icon-checkbox.component.html',
  styleUrls: ['./icon-checkbox.component.scss']
})
export class IconCheckboxComponent {

  @Input('data') data!: IconCheckbox;
  @Input('theme') theme!: string;
  @Input('selectable') selectable = true;
  @Output('state-changed') stateChanged = new EventEmitter<boolean>();


  toggleState() {
    if(this.selectable) {
      if(this.data) {
        this.data.selected = !this.data.selected;
        this.stateChanged.emit(this.data.selected);
      }
    }

  }
}
